module.exports = __webpack_public_path__ + "static/img/04.ec894a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/04.jpg
// module id = 378
// module chunks = 1